<script setup lang="ts">
/**
 * Loading skeleton: render 4 summary cards + N provider cards as shimmering
 * placeholders. Shown within 200ms of request start; the composable sets
 * state to 'loading' immediately, so this view appears instantly.
 *
 * Number of provider placeholders is configurable (defaults to 6).
 */
interface Props {
  readonly providerCount?: number;
}
withDefaults(defineProps<Props>(), { providerCount: 6 });
</script>

<template>
  <div class="skeleton" role="status" aria-live="polite" aria-busy="true">
    <span class="sr-only">正在加载用量数据…</span>
    <div class="skeleton-grid">
      <div
        v-for="i in 4"
        :key="`sum-${i}`"
        class="skeleton-card"
      ></div>
    </div>
    <div class="provider-grid" aria-hidden="true">
      <div
        v-for="i in providerCount"
        :key="`prov-${i}`"
        class="skeleton-provider"
      ></div>
    </div>
  </div>
</template>
